export default [
    {
        "name": "1977",
        "is_done": true,
        "usage": "_1977"
    },
    {
        "name": "Aden",
        "is_done": true,
        "usage": "aden"
    },
    {
        "name": "Amaro",
        "is_done": false,
        "usage": "amaro"
    },
    {
        "name": "Ashby",
        "is_done": false,
        "usage": "ashby"
    },
    {
        "name": "Brannan",
        "is_done": true,
        "usage": "brannan"
    },
    {
        "name": "Brooklyn",
        "is_done": true,
        "usage": "brooklyn"
    },
    {
        "name": "Charmes",
        "is_done": false,
        "usage": "charmes"
    },
    {
        "name": "Clarendon",
        "is_done": true,
        "usage": "clarendon"
    },
    {
        "name": "Crema",
        "is_done": false,
        "usage": "crema"
    },
    {
        "name": "Dogpatch",
        "is_done": false,
        "usage": "dogpatch"
    },
    {
        "name": "Earlybird",
        "is_done": true,
        "usage": "earlybird"
    },
    {
        "name": "Gingham",
        "is_done": true,
        "usage": "gingham"
    },
    {
        "name": "Ginza",
        "is_done": false,
        "usage": "ginza"
    },
    {
        "name": "Hefe",
        "is_done": false,
        "usage": "hefe"
    },
    {
        "name": "Helena",
        "is_done": false,
        "usage": "helena"
    },
    {
        "name": "Hudson",
        "is_done": true,
        "usage": "hudson"
    },
    {
        "name": "Inkwell",
        "is_done": true,
        "usage": "inkwell"
    },
    {
        "name": "Juno",
        "is_done": false,
        "usage": "juno"
    },
    {
        "name": "Kelvin",
        "is_done": true,
        "usage": "kelvin"
    },
    {
        "name": "Lark",
        "is_done": true,
        "usage": "lark"
    },
    {
        "name": "Lo-Fi",
        "is_done": true,
        "usage": "lofi"
    },
    {
        "name": "Ludwig",
        "is_done": false,
        "usage": "ludwig"
    },
    {
        "name": "Maven",
        "is_done": true,
        "usage": "maven"
    },
    {
        "name": "Mayfair",
        "is_done": true,
        "usage": "mayfair"
    },
    {
        "name": "Moon",
        "is_done": true,
        "usage": "moon"
    },
    {
        "name": "Nashville",
        "is_done": true,
        "usage": "nashville"
    },
    {
        "name": "Perpetua",
        "is_done": true,
        "usage": "perpetua"
    },
    {
        "name": "Reyes",
        "is_done": true,
        "usage": "reyes"
    },
    {
        "name": "Rise",
        "is_done": true,
        "usage": "rise"
    },
    {
        "name": "Sierra",
        "is_done": false,
        "usage": "sierra"
    },
    {
        "name": "Skyline",
        "is_done": false,
        "usage": "skyline"
    },
    {
        "name": "Slumber",
        "is_done": true,
        "usage": "slumber"
    },
    {
        "name": "Stinson",
        "is_done": true,
        "usage": "stinson"
    },
    {
        "name": "Sutro",
        "is_done": false,
        "usage": "sutro"
    },
    {
        "name": "Toaster",
        "is_done": true,
        "usage": "toaster"
    },
    {
        "name": "Valencia",
        "is_done": true,
        "usage": "valencia"
    },
    {
        "name": "Vesper",
        "is_done": false,
        "usage": "vesper"
    },
    {
        "name": "Walden",
        "is_done": true,
        "usage": "walden"
    },
    {
        "name": "Willow",
        "is_done": true,
        "usage": "willow"
    },
    {
        "name": "X-pro II",
        "is_done": true,
        "usage": "xpro2"
    }
]